import { Alert } from '@/components/ui/Alert';

/**
 * What a user sees when a standard report run failed: one short line.
 *
 * Shared by the runner (StandardReportRunnerPage) and the past-run viewer
 * (StandardRunViewer) so one failure reads the same on both. The cause belongs
 * in the run's stored error and the logs, not on this screen.
 */
export function StandardRunFailedAlert() {
  return <Alert variant="error">This report encountered an error.</Alert>;
}
